import {
  CancellationProposal,
  CancellationProposalFlightBound,
} from "../types/Cancellation";

export const getBoundsFromCancellationProposal = (
  cancellationProposal: CancellationProposal
): CancellationProposalFlightBound[] => {
  return [
    cancellationProposal.flightSchedule?.outbound,
    cancellationProposal.flightSchedule?.inbound,
  ].filter(isBound);
};

const isBound = (
  bound: CancellationProposalFlightBound | null | undefined
): bound is CancellationProposalFlightBound => {
  return !!bound;
};
